import ScrollUp from './scroll-up';

export default class ScrollUpDesktop extends ScrollUp {
    constructor(...args) {
        super(...args);

    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/scroll-up/scroll-up.desktop.js